import { rei } from "@/services/api"
import http from 'http'
import https from 'https'

const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })


class HabilitacaoService {
  static getHabilitacaoById (id, cartorio_id) {
    return rei.get(`habilitacao-casamento/${id}`, { params: { cartorio_id } })
      .then(res => res.data)
  }

  static storeHabilitacao (habilitacao) {
    // limpamos o telefone
    // (99) 99999-9999 => 99999999999
    habilitacao.pessoas[0].contato = HabilitacaoService.clearPhone(habilitacao.pessoas[0].contato)
    habilitacao.pessoas[1].contato = HabilitacaoService.clearPhone(habilitacao.pessoas[1].contato)

    return rei.post(`habilitacao-casamento`, habilitacao).then(res => res.data)
  }

  static updateHabilitacao (habilitacao, id) {
    // limpamos o telefone
    // (99) 99999-9999 => 99999999999
    if (habilitacao.registro && habilitacao.registro.pessoas) {
      habilitacao.registro.pessoas[0].contato = HabilitacaoService.clearPhone(habilitacao.registro.pessoas[0].contato)
      habilitacao.registro.pessoas[1].contato = HabilitacaoService.clearPhone(habilitacao.registro.pessoas[1].contato)
    }

    return rei.put(`habilitacao-casamento/${ id }`, habilitacao).then(res => res.data)
  }

  static gerarAutuacao (data) {
    return rei.post(`habilitacao-casamento/gerar-autuacao`, data, {httpAgent}).then(res => res.data)
  }

  static iniciarAssinaturaAutuacao (certificate, documento) {
    const payload = {
      certificate: certificate,
      documento: documento,
    }

    return rei.post(`habilitacao-casamento/gerar-autuacao/iniciar-assinatura`, payload, {httpAgent}).then(res => res.data)
  }

  static finalizarAssinaturaAutuacao (bryNonce, signatures, habilitacao) {
    const payload = {
      bryNonce,
      signatures,
      habilitacao
    }

    return rei.post(`habilitacao-casamento/gerar-autuacao/finalizar-assinatura`, payload, {httpAgent})
      .then(res => res.data)
  }

  static getTemplateMemorial (id, params) {
    return rei.get(`impressao/habilitacao-casamento/memorial/rascunho/${id}`, { params })
      .then(res => res.data)
  }

  static getTemplateMemorialRegistro (id, params) {
    return rei.get(`impressao/habilitacao-casamento/memorial/registro/${id}`, { params })
      .then(res => res.data)
  }

  static getTemplateMemorialAditivo (id, params) {
    return rei.get(`impressao/habilitacao-casamento/memorial/aditivo/${id}`, { params })
      .then(res=> res.data)
  }

  static getMemorialPDF (html, preview = false) {
    return rei.post(`impressao/habilitacao-casamento/memorial${ preview && `?preview=1` || `` }`, {html}, { responseType: 'arraybuffer' }).then(res => res.data)
  }

  static getTemplateCertidao (data) {
    return rei.post(`impressao/habilitacao-casamento/previa/certidao`, data).then(res => res.data)
  }
  
  static getTemplateCertidaoEletronica (data) {
    return rei.post(`impressao/habilitacao-casamento/previa/certidao-eletronica`, data).then(res => res.data)
  }

  static getPdfCertidao (data, preview = false) {
    return rei.post(`impressao/habilitacao-casamento/certidao${ preview && `?preview=1` || `` }`, data, { responseType: 'arraybuffer' })
      .then(res => res.data)
  }

  static getPdfEdital (html, preview = false) {
    return rei.post(`impressao/templates/habilitacao/edital${ preview && `?preview=1` || `` }`, { html }, { responseType: 'arraybuffer' })
      .then(res => res.data)
  }

  static getPdfCadastroHabilitacao (html, habilitacao = null) {
    return rei.post(`impressao/templates/habilitacao/edital-declaracoes-casamento`, { html, habilitacao }, { responseType: 'arraybuffer' }).then(res => res.data)
  }
  static clearPhone (contato) {
    return {
      ...contato,
      telefone_1: contato ? limparString(contato.telefone_1) : null,
      telefone_2: contato ? limparString(contato.telefone_2) : null,
      email: contato ? contato.email : null
    }
  }

  static updateProtocoloAutomatico (data, id) {
    return rei.put(`habilitacao-casamento/protocolo-automatico/${ id }`, data).then(res => res.data)
  }
}

export default HabilitacaoService
